import { render } from "./ProductCard.vue?vue&type=template&id=4586e7ce&scoped=true&ts=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"

import "./ProductCard.vue?vue&type=style&index=0&id=4586e7ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4586e7ce"]])

export default __exports__